import { ROLES } from '../../auth/constants';

const config = {
  SITE: 'quality_nonprod',
  LABEL: 'Quality',
  SITE_ID: 'groups.coca-cola.com,18f2d0a2-e373-4c4a-b16f-64378e8812b8,ec7f5839-4ac7-44e8-ba35-5d6c46a20027',
  PAGES_LIST_ID: 'cf197018-6291-4a86-928c-4facc46dd357',
  DOCUMENTS_LIST_ID: '56eb9576-019e-4296-868e-c21dbbfa5ccd',
  SITE_ASSETS_DRIVE_ID: 'b!otDyGHPjSkyxb2Q3jogSuDlYf-zHSuhEujVdbEaiACdk8HIjYxhpRr-MnH1rAi-V',
  DOCUMENTS_DRIVE_ID: 'b!otDyGHPjSkyxb2Q3jogSuDlYf-zHSuhEujVdbEaiACd2letWngGWQoaOwh27-lzN',
  NEWS_TEMPLATE_ID: '84ea449a-2e7b-4f83-9670-cdc63933ef14',
  SETTINGS_FILE_PATH: 'Settings/HubSettings.json',
  OPT_OUT_FILE_PATH: 'Settings/EmailOptOut.txt',
  MANAGER_ROLES: [ROLES.QSE_MGR, ROLES.IM_MANAGER],
  VIVA_COMMUNITY_ID: undefined,
  libraryDrives: [
    {
      name: 'Quality Food Safety',
      label: 'Quality & Food Safety',
      driveId: 'b!otDyGHPjSkyxb2Q3jogSuDlYf-zHSuhEujVdbEaiACeTEiL7D72DSrcOIZjEajaQ',
      listId: 'fb221293-bd0f-4a83-b70e-2198c46a3690'
    },
    {
      name: 'FSOP',
      label: 'FSOP',
      driveId: 'b!otDyGHPjSkyxb2Q3jogSuDlYf-zHSuhEujVdbEaiACeyjKDDiz1nSJdnncPB1pKh',
      listId: 'c3a08cb2-3d8b-4867-9767-9dc3c1d692a1'
    },
    {
      name: 'Supplier',
      label: 'Supplier Quality',
      driveId: 'b!otDyGHPjSkyxb2Q3jogSuDlYf-zHSuhEujVdbEaiACcHARAd_7NQRLk2v1-2cabh',
      listId: '1d100107-b3ff-4450-b936-bf5fb671a6e1'
    }
  ]
}

export default config